import classes from './radio-button.module.scss';
import Conditional from '@next-app/components/Conditional';

interface RadioButtonProps {
  label: string;
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
  classname?: string;
  datatestid?: string;
  btncustomclass?: string;
  automationId?: string;
  isDisabled?: boolean;
  labelClass?: string;
  pdpRedesignEnabled?: boolean;
  iconClass?: string;
  isSelected?: boolean;
  id?: string;
}

const RadioButton: React.FC<RadioButtonProps> = (props) => {
  const {
    label,
    value,
    checked,
    onChange,
    classname,
    datatestid,
    automationId,
    isDisabled,
    btncustomclass,
    labelClass,
    pdpRedesignEnabled = false,
    iconClass,
    isSelected,
    id,
  } = props;

  const handleChange = () => {
    onChange(value);
  };

  const stableId =
    id ?? `radio-${value}-${label}`.replace(/[^a-zA-Z0-9-]/g, '-');
  return (
    <div
      className={`${classes.radioButtonFieldControl} ${pdpRedesignEnabled ? classes.new : ''} position-relative ${classname ?? ''}`}
    >
      <label className="d-flex align-items-center" htmlFor={stableId}>
        <input
          data-automation-id={automationId}
          type="radio"
          value={value}
          checked={checked}
          onChange={handleChange}
          className={classes.radio}
          data-testid={datatestid}
          disabled={isDisabled}
          id={stableId}
        />
        <Conditional if={!pdpRedesignEnabled}>
          <div
            className={`${classes['radio-button-indicator']} ${btncustomclass ?? ''}`}
          ></div>
        </Conditional>
        <Conditional if={pdpRedesignEnabled}>
          <div className={`ls-icon ${iconClass}`}></div>
        </Conditional>
        <span
          className={`ll-fs-14 ${classes.radioButtonLabel} ${labelClass} ${pdpRedesignEnabled && isSelected ? 'fw-bold' : ''}`}
        >
          {label}
        </span>
      </label>
    </div>
  );
};

export default RadioButton;
